'use client';

import { useNavigation } from '@/components/navigation/navigation-context';
import { useIsMobile } from '@/lib/is-mobile';

export function useBottomPosition() {
  const isMobile = useIsMobile();

  let bottomPosition = 'env(safe-area-inset-bottom)';

  if (isMobile) {
    try {
      const { isNavigationVisible, navigationHeight } = useNavigation();

      if (isNavigationVisible) {
        bottomPosition = `calc(env(safe-area-inset-bottom) + ${navigationHeight}px)`;
      }
    } catch {
      // Fallback nếu không có NavigationProvider
      bottomPosition = 'calc(env(safe-area-inset-bottom) + 4rem)';
    }
  }

  return { bottomPosition, isMobile };
}
